var _polygon;
import * as React from "react";
var SvgMore = function SvgMore(props) {
  return _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    stroke: "none",
    fill: "currentColor",
    fillRule: "evenodd",
    points: "9.00349603 1 9.00349603 7.0085634 15 7.00919977 15 9.00645472 9.00349603 9.00645472 9.00349603 15 7.00808703 15 7.00808703 9.00645472 1 9.00645472 1 7.00919977 7.00808703 7.00919977 7.00808703 1"
  }));
};
export default SvgMore;